var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 4.97327,
    width: 11,
    height: 10.0269,
    stroke: "#444444"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3.5,
    width: 1,
    height: 2.91889,
    fill: "#444444"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 3.5,
    width: 1,
    height: 2.91889,
    fill: "#444444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75025 8.87164L14.2481 8.87666",
    stroke: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlack);
export default __webpack_public_path__ + "static/media/calendar-black.326da855859c26eb33ffef2aaf191d03.svg";
export { ForwardRef as ReactComponent };